import React from "react";
import ListSelectedComponenttype from "./ListSelectedComponenttype";
import Paper from "@mui/material/Paper";
import {makeStyles} from "@mui/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    paper: {
        width: 400,
        height: 300,
        overflow: 'auto',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
}));

function ListSelectedComponenttypeBox({selectedComponenttypes, deleteComponenttype}) {
    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <ListSelectedComponenttype
                selectedComponenttypes={selectedComponenttypes}
                deleteComponenttype={deleteComponenttype}
            />
        </Paper>
    );
}

export default ListSelectedComponenttypeBox;
